import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ShopDetailsMain from '../Components/Shop/ShopDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function ShopDetails() {
    return (
        <>
            <SEO 
                title="Product Details - Tourm Travel Shop"
                description="View product details and information from our travel shop."
                url="/shop"
            />
            <HeaderOne />
            <Breadcrumb
                title='Shop Details'
            />
            <ShopDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default ShopDetails
